import { IConfigMapping } from './IConfigMapping';

export const Compliance: IConfigMapping = {
    complianceGdpr: 'compliance.gdpr'
};
